const getWorkflowTask = async (_, data) => {
  const resp = await window.axios.get(`/proxy/workflows/${data.storageId}/tasks/${data.taskId}`);
  return resp.data;
};

export default getWorkflowTask;
